import { createDecorator } from 'vue-class-component'

export const qs = ( selector: string, ctx = document ) => ctx.querySelector( selector )

export const qsa = ( selector: string, ctx = document ) => Array.from( ctx.querySelectorAll( selector ) )

const getDevice = () => {
    let device = window.getComputedStyle( document.body, '::after' ).getPropertyValue( 'content' )
    device = device.replace( /('|")/g, '' )

    return device
}

export function isMobile() {
    return !( getDevice() !== 'xxs' && getDevice() !== 'xs' )
}

export function isTablet() {
    return !( getDevice() !== 'sm' && getDevice() !== 'md' )
}

export function isMediumScreen() {
    return ( getDevice() !== 'xxs' && getDevice() !== 'xs' && getDevice() !== 'sm' )
}

export function getBrowserLocale(options = {}) {
    const defaultOptions = { countryCodeOnly: false }

    const opt = { ...defaultOptions, ...options }

    const navigatorLocale =
        navigator.languages !== undefined
            ? navigator.languages[0]
            : navigator.language

    if (!navigatorLocale) {
        return undefined
    }

    return opt.countryCodeOnly
        ? navigatorLocale.trim().split(/-|_/)[0]
        : navigatorLocale.trim()
}

export const Meta = createDecorator( ( options, key ) => {
    if ( !options.methods ) return
    options['metaInfo'] = options.methods[key]
} )
